"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=require("@material-ui/core/styles");let b=a.makeStyles(a=>({footer:{backgroundColor:a.palette.common.gray100,padding:a.spacing(2,4),[a.breakpoints.down("xs")]:{padding:a.spacing(1.5,3)}}}));exports.default=b
//# sourceMappingURL=styles.js.map
